/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamExamidLangs202,
  PostApiV1ExamExamidLangs401,
  PostApiV1ExamExamidLangs404,
  PostApiV1ExamExamidLangs500,
  PostApiV1ExamExamidLangsMutationRequest,
  PostApiV1ExamExamidLangsMutationResponse,
  PostApiV1ExamExamidLangsPathParams,
} from "../../types/examEvaluationController/PostApiV1ExamExamidLangs.ts";
import { examLangCreateViewModelSchema } from "../examLangCreateViewModelSchema.ts";

export const postApiV1ExamExamidLangsPathParamsSchema = z.object({
  examId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ExamExamidLangsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamExamidLangs202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamidLangs202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamExamidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ExamExamidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamExamidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamExamidLangs500>;

export const postApiV1ExamExamidLangsMutationRequestSchema = z.lazy(
  () => examLangCreateViewModelSchema,
) as unknown as ToZod<PostApiV1ExamExamidLangsMutationRequest>;

export const postApiV1ExamExamidLangsMutationResponseSchema = z.lazy(
  () => postApiV1ExamExamidLangs202Schema,
) as unknown as ToZod<PostApiV1ExamExamidLangsMutationResponse>;
